import type { PlcManufacturerFaultLibrary } from "./types";

export const deltaFaultLibrary: PlcManufacturerFaultLibrary = {
  manufacturer_id: "delta",
  manufacturer_name: "Delta Electronics",
  faults: [
    {
      id: "delta-delta-ah-ah500-motion-cpu-no-power",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "AH500 Motion CPU ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "AH500 Motion CPU يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "AH500 Motion CPU يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Watchdog مال AH500 Motion CPU يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Scan Time مال AH500 Motion CPU عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "حرارة AH500 Motion CPU ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-battery",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Battery/Backup مال AH500 Motion CPU ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-memory",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Memory Error في AH500 Motion CPU",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-retain",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "بيانات Retain مال AH500 Motion CPU تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-rtc",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "ساعة RTC مال AH500 Motion CPU غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-firmware",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Firmware مال AH500 Motion CPU مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Project داخل AH500 Motion CPU مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Download إلى AH500 Motion CPU يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Upload من AH500 Motion CPU يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-password",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ AH500 Motion CPU",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "password", "protection", "access"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ AH500 Motion CPU",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ AH500 Motion CPU",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-network-link",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Ethernet Link مال AH500 Motion CPU ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا AH500 Motion CPU يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا AH500 Motion CPU ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Remote I/O مرتبط بـ AH500 Motion CPU Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Module مفقود من تكوين AH500 Motion CPU",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Module type/revision mismatch ويا AH500 Motion CPU",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-backplane",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Backplane/Bus Fault مال AH500 Motion CPU",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Digital Input ما يقرا على AH500 Motion CPU",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Input على AH500 Motion CPU يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "input stuck", "di"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Output على AH500 Motion CPU يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Analog Input على AH500 Motion CPU يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Analog Input على AH500 Motion CPU يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Analog Reading على AH500 Motion CPU تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Analog Output من AH500 Motion CPU مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-hsc",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "High Speed Counter على AH500 Motion CPU ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-encoder",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Encoder ويا AH500 Motion CPU يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-force",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Force/Override فعال على AH500 Motion CPU",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-interlock",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من AH500 Motion CPU",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-safety",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ AH500 Motion CPU يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-motion",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Motion/Axis command من AH500 Motion CPU يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-pid",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "PID داخل AH500 Motion CPU غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-startup",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "AH500 Motion CPU ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "AH500 Motion CPU يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "بيانات داخل AH500 Motion CPU تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-ah-ah500-motion-cpu-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Motion CPU",
      code: null,
      title_ar: "Diagnostic/Event log مال AH500 Motion CPU مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Motion CPU",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Motion CPU", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-no-power",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "AH500 Redundant CPU ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "AH500 Redundant CPU يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "AH500 Redundant CPU يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Watchdog مال AH500 Redundant CPU يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Scan Time مال AH500 Redundant CPU عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "حرارة AH500 Redundant CPU ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-battery",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Battery/Backup مال AH500 Redundant CPU ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-memory",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Memory Error في AH500 Redundant CPU",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-retain",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "بيانات Retain مال AH500 Redundant CPU تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-rtc",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "ساعة RTC مال AH500 Redundant CPU غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-firmware",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Firmware مال AH500 Redundant CPU مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Project داخل AH500 Redundant CPU مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Download إلى AH500 Redundant CPU يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Upload من AH500 Redundant CPU يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-password",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ AH500 Redundant CPU",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "password", "protection", "access"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ AH500 Redundant CPU",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ AH500 Redundant CPU",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-network-link",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Ethernet Link مال AH500 Redundant CPU ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا AH500 Redundant CPU يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا AH500 Redundant CPU ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Remote I/O مرتبط بـ AH500 Redundant CPU Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Module مفقود من تكوين AH500 Redundant CPU",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Module type/revision mismatch ويا AH500 Redundant CPU",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-backplane",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Backplane/Bus Fault مال AH500 Redundant CPU",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Digital Input ما يقرا على AH500 Redundant CPU",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Input على AH500 Redundant CPU يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "input stuck", "di"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Output على AH500 Redundant CPU يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Analog Input على AH500 Redundant CPU يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Analog Input على AH500 Redundant CPU يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Analog Reading على AH500 Redundant CPU تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Analog Output من AH500 Redundant CPU مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-hsc",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "High Speed Counter على AH500 Redundant CPU ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-encoder",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Encoder ويا AH500 Redundant CPU يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-force",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Force/Override فعال على AH500 Redundant CPU",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-interlock",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من AH500 Redundant CPU",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-safety",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ AH500 Redundant CPU يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-motion",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Motion/Axis command من AH500 Redundant CPU يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-pid",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "PID داخل AH500 Redundant CPU غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-startup",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "AH500 Redundant CPU ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "AH500 Redundant CPU يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "بيانات داخل AH500 Redundant CPU تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-ah-ah500-redundant-cpu-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Redundant CPU",
      code: null,
      title_ar: "Diagnostic/Event log مال AH500 Redundant CPU مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Redundant CPU",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Redundant CPU", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-no-power",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "AH500 Standard CPU ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "AH500 Standard CPU يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "AH500 Standard CPU يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Watchdog مال AH500 Standard CPU يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Scan Time مال AH500 Standard CPU عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "حرارة AH500 Standard CPU ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-battery",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Battery/Backup مال AH500 Standard CPU ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-memory",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Memory Error في AH500 Standard CPU",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-retain",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "بيانات Retain مال AH500 Standard CPU تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-rtc",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "ساعة RTC مال AH500 Standard CPU غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-firmware",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Firmware مال AH500 Standard CPU مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Project داخل AH500 Standard CPU مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Download إلى AH500 Standard CPU يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Upload من AH500 Standard CPU يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-password",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ AH500 Standard CPU",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "password", "protection", "access"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ AH500 Standard CPU",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ AH500 Standard CPU",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-network-link",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Ethernet Link مال AH500 Standard CPU ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا AH500 Standard CPU يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا AH500 Standard CPU ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Remote I/O مرتبط بـ AH500 Standard CPU Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Module مفقود من تكوين AH500 Standard CPU",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Module type/revision mismatch ويا AH500 Standard CPU",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-backplane",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Backplane/Bus Fault مال AH500 Standard CPU",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Digital Input ما يقرا على AH500 Standard CPU",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Input على AH500 Standard CPU يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "input stuck", "di"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Output على AH500 Standard CPU يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Analog Input على AH500 Standard CPU يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Analog Input على AH500 Standard CPU يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Analog Reading على AH500 Standard CPU تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Analog Output من AH500 Standard CPU مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-hsc",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "High Speed Counter على AH500 Standard CPU ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-encoder",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Encoder ويا AH500 Standard CPU يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-force",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Force/Override فعال على AH500 Standard CPU",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-interlock",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من AH500 Standard CPU",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-safety",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ AH500 Standard CPU يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-motion",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Motion/Axis command من AH500 Standard CPU يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-pid",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "PID داخل AH500 Standard CPU غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-startup",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "AH500 Standard CPU ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "AH500 Standard CPU يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "بيانات داخل AH500 Standard CPU تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-ah-ah500-standard-cpu-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: "AH500 Standard CPU",
      code: null,
      title_ar: "Diagnostic/Event log مال AH500 Standard CPU مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AH500 Standard CPU",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AH Series", "AH500 Standard CPU", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-no-power",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "AS200 Standard CPU ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "AS200 Standard CPU يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "AS200 Standard CPU يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Watchdog مال AS200 Standard CPU يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Scan Time مال AS200 Standard CPU عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "حرارة AS200 Standard CPU ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-battery",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Battery/Backup مال AS200 Standard CPU ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-memory",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Memory Error في AS200 Standard CPU",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-retain",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "بيانات Retain مال AS200 Standard CPU تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-rtc",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "ساعة RTC مال AS200 Standard CPU غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-firmware",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Firmware مال AS200 Standard CPU مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Project داخل AS200 Standard CPU مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Download إلى AS200 Standard CPU يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Upload من AS200 Standard CPU يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-password",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ AS200 Standard CPU",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "password", "protection", "access"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ AS200 Standard CPU",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ AS200 Standard CPU",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-network-link",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Ethernet Link مال AS200 Standard CPU ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا AS200 Standard CPU يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا AS200 Standard CPU ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Remote I/O مرتبط بـ AS200 Standard CPU Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Module مفقود من تكوين AS200 Standard CPU",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Module type/revision mismatch ويا AS200 Standard CPU",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-backplane",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Backplane/Bus Fault مال AS200 Standard CPU",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Digital Input ما يقرا على AS200 Standard CPU",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Input على AS200 Standard CPU يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "input stuck", "di"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Output على AS200 Standard CPU يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Analog Input على AS200 Standard CPU يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Analog Input على AS200 Standard CPU يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Analog Reading على AS200 Standard CPU تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Analog Output من AS200 Standard CPU مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-hsc",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "High Speed Counter على AS200 Standard CPU ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-encoder",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Encoder ويا AS200 Standard CPU يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-force",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Force/Override فعال على AS200 Standard CPU",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-interlock",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من AS200 Standard CPU",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-safety",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ AS200 Standard CPU يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-motion",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Motion/Axis command من AS200 Standard CPU يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-pid",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "PID داخل AS200 Standard CPU غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-startup",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "AS200 Standard CPU ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "AS200 Standard CPU يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "بيانات داخل AS200 Standard CPU تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-as-as200-standard-cpu-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS200 Standard CPU",
      code: null,
      title_ar: "Diagnostic/Event log مال AS200 Standard CPU مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS200 Standard CPU",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS200 Standard CPU", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-no-power",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "AS300 Motion CPU ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "AS300 Motion CPU يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "AS300 Motion CPU يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Watchdog مال AS300 Motion CPU يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Scan Time مال AS300 Motion CPU عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "حرارة AS300 Motion CPU ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-battery",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Battery/Backup مال AS300 Motion CPU ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-memory",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Memory Error في AS300 Motion CPU",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-retain",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "بيانات Retain مال AS300 Motion CPU تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-rtc",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "ساعة RTC مال AS300 Motion CPU غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-firmware",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Firmware مال AS300 Motion CPU مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Project داخل AS300 Motion CPU مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Download إلى AS300 Motion CPU يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Upload من AS300 Motion CPU يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-password",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ AS300 Motion CPU",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "password", "protection", "access"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ AS300 Motion CPU",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ AS300 Motion CPU",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-network-link",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Ethernet Link مال AS300 Motion CPU ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا AS300 Motion CPU يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا AS300 Motion CPU ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Remote I/O مرتبط بـ AS300 Motion CPU Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Module مفقود من تكوين AS300 Motion CPU",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Module type/revision mismatch ويا AS300 Motion CPU",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-backplane",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Backplane/Bus Fault مال AS300 Motion CPU",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Digital Input ما يقرا على AS300 Motion CPU",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Input على AS300 Motion CPU يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "input stuck", "di"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Output على AS300 Motion CPU يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Analog Input على AS300 Motion CPU يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Analog Input على AS300 Motion CPU يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Analog Reading على AS300 Motion CPU تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Analog Output من AS300 Motion CPU مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-hsc",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "High Speed Counter على AS300 Motion CPU ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-encoder",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Encoder ويا AS300 Motion CPU يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-force",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Force/Override فعال على AS300 Motion CPU",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-interlock",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من AS300 Motion CPU",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-safety",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ AS300 Motion CPU يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-motion",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Motion/Axis command من AS300 Motion CPU يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-pid",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "PID داخل AS300 Motion CPU غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-startup",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "AS300 Motion CPU ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "AS300 Motion CPU يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "بيانات داخل AS300 Motion CPU تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-as-as300-motion-cpu-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Motion CPU",
      code: null,
      title_ar: "Diagnostic/Event log مال AS300 Motion CPU مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Motion CPU",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Motion CPU", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-no-power",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "AS300 Standard CPU ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "AS300 Standard CPU يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "AS300 Standard CPU يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Watchdog مال AS300 Standard CPU يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Scan Time مال AS300 Standard CPU عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "حرارة AS300 Standard CPU ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-battery",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Battery/Backup مال AS300 Standard CPU ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-memory",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Memory Error في AS300 Standard CPU",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-retain",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "بيانات Retain مال AS300 Standard CPU تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-rtc",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "ساعة RTC مال AS300 Standard CPU غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-firmware",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Firmware مال AS300 Standard CPU مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Project داخل AS300 Standard CPU مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Download إلى AS300 Standard CPU يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Upload من AS300 Standard CPU يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-password",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ AS300 Standard CPU",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "password", "protection", "access"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ AS300 Standard CPU",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ AS300 Standard CPU",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-network-link",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Ethernet Link مال AS300 Standard CPU ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا AS300 Standard CPU يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا AS300 Standard CPU ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Remote I/O مرتبط بـ AS300 Standard CPU Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Module مفقود من تكوين AS300 Standard CPU",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Module type/revision mismatch ويا AS300 Standard CPU",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-backplane",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Backplane/Bus Fault مال AS300 Standard CPU",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Digital Input ما يقرا على AS300 Standard CPU",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Input على AS300 Standard CPU يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "input stuck", "di"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Output على AS300 Standard CPU يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Analog Input على AS300 Standard CPU يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Analog Input على AS300 Standard CPU يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Analog Reading على AS300 Standard CPU تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Analog Output من AS300 Standard CPU مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-hsc",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "High Speed Counter على AS300 Standard CPU ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-encoder",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Encoder ويا AS300 Standard CPU يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-force",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Force/Override فعال على AS300 Standard CPU",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-interlock",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من AS300 Standard CPU",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-safety",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ AS300 Standard CPU يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-motion",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Motion/Axis command من AS300 Standard CPU يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-pid",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "PID داخل AS300 Standard CPU غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-startup",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "AS300 Standard CPU ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "AS300 Standard CPU يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "بيانات داخل AS300 Standard CPU تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-as-as300-standard-cpu-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AS300 Standard CPU",
      code: null,
      title_ar: "Diagnostic/Event log مال AS300 Standard CPU مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AS300 Standard CPU",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AS300 Standard CPU", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-no-power",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "AX-3 Motion CPU ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "AX-3 Motion CPU يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "AX-3 Motion CPU يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Watchdog مال AX-3 Motion CPU يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Scan Time مال AX-3 Motion CPU عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "حرارة AX-3 Motion CPU ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-battery",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Battery/Backup مال AX-3 Motion CPU ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-memory",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Memory Error في AX-3 Motion CPU",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-retain",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "بيانات Retain مال AX-3 Motion CPU تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-rtc",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "ساعة RTC مال AX-3 Motion CPU غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-firmware",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Firmware مال AX-3 Motion CPU مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Project داخل AX-3 Motion CPU مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Download إلى AX-3 Motion CPU يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Upload من AX-3 Motion CPU يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-password",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ AX-3 Motion CPU",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "password", "protection", "access"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ AX-3 Motion CPU",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ AX-3 Motion CPU",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-network-link",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Ethernet Link مال AX-3 Motion CPU ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا AX-3 Motion CPU يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا AX-3 Motion CPU ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Remote I/O مرتبط بـ AX-3 Motion CPU Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Module مفقود من تكوين AX-3 Motion CPU",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Module type/revision mismatch ويا AX-3 Motion CPU",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-backplane",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Backplane/Bus Fault مال AX-3 Motion CPU",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Digital Input ما يقرا على AX-3 Motion CPU",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Input على AX-3 Motion CPU يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "input stuck", "di"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Output على AX-3 Motion CPU يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Analog Input على AX-3 Motion CPU يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Analog Input على AX-3 Motion CPU يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Analog Reading على AX-3 Motion CPU تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Analog Output من AX-3 Motion CPU مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-hsc",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "High Speed Counter على AX-3 Motion CPU ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-encoder",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Encoder ويا AX-3 Motion CPU يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-force",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Force/Override فعال على AX-3 Motion CPU",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-interlock",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من AX-3 Motion CPU",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-safety",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ AX-3 Motion CPU يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-motion",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Motion/Axis command من AX-3 Motion CPU يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-pid",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "PID داخل AX-3 Motion CPU غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-startup",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "AX-3 Motion CPU ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "AX-3 Motion CPU يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "بيانات داخل AX-3 Motion CPU تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-as-ax-3-motion-cpu-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-as",
      model: "AX-3 Motion CPU",
      code: null,
      title_ar: "Diagnostic/Event log مال AX-3 Motion CPU مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "AX-3 Motion CPU",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "AS Series", "AX-3 Motion CPU", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "DVP-10PM ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "DVP-10PM يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "DVP-10PM يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Watchdog مال DVP-10PM يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Scan Time مال DVP-10PM عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "حرارة DVP-10PM ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Battery/Backup مال DVP-10PM ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Memory Error في DVP-10PM",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "بيانات Retain مال DVP-10PM تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "ساعة RTC مال DVP-10PM غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Firmware مال DVP-10PM مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Project داخل DVP-10PM مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Download إلى DVP-10PM يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Upload من DVP-10PM يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-10PM",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-10PM",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-10PM",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Ethernet Link مال DVP-10PM ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-10PM يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-10PM ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-10PM Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-10PM",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-10PM",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-10PM",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-10PM",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Input على DVP-10PM يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Output على DVP-10PM يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Analog Input على DVP-10PM يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Analog Input على DVP-10PM يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Analog Reading على DVP-10PM تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Analog Output من DVP-10PM مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "High Speed Counter على DVP-10PM ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Encoder ويا DVP-10PM يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Force/Override فعال على DVP-10PM",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-10PM",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-10PM يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Motion/Axis command من DVP-10PM يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "PID داخل DVP-10PM غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "DVP-10PM ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "DVP-10PM يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "بيانات داخل DVP-10PM تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-10pm-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-10PM",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-10PM مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-10PM",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-10PM", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "DVP-15MC ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "DVP-15MC يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "DVP-15MC يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Watchdog مال DVP-15MC يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Scan Time مال DVP-15MC عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "حرارة DVP-15MC ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Battery/Backup مال DVP-15MC ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Memory Error في DVP-15MC",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "بيانات Retain مال DVP-15MC تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "ساعة RTC مال DVP-15MC غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Firmware مال DVP-15MC مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Project داخل DVP-15MC مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Download إلى DVP-15MC يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Upload من DVP-15MC يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-15MC",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-15MC",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-15MC",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Ethernet Link مال DVP-15MC ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-15MC يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-15MC ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-15MC Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-15MC",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-15MC",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-15MC",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-15MC",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Input على DVP-15MC يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Output على DVP-15MC يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Analog Input على DVP-15MC يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Analog Input على DVP-15MC يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Analog Reading على DVP-15MC تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Analog Output من DVP-15MC مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "High Speed Counter على DVP-15MC ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Encoder ويا DVP-15MC يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Force/Override فعال على DVP-15MC",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-15MC",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-15MC يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Motion/Axis command من DVP-15MC يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "PID داخل DVP-15MC غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "DVP-15MC ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "DVP-15MC يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "بيانات داخل DVP-15MC تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-15mc-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-15MC",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-15MC مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-15MC",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-15MC", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "DVP-20PM ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "DVP-20PM يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "DVP-20PM يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Watchdog مال DVP-20PM يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Scan Time مال DVP-20PM عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "حرارة DVP-20PM ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Battery/Backup مال DVP-20PM ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Memory Error في DVP-20PM",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "بيانات Retain مال DVP-20PM تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "ساعة RTC مال DVP-20PM غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Firmware مال DVP-20PM مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Project داخل DVP-20PM مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Download إلى DVP-20PM يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Upload من DVP-20PM يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-20PM",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-20PM",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-20PM",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Ethernet Link مال DVP-20PM ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-20PM يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-20PM ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-20PM Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-20PM",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-20PM",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-20PM",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-20PM",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Input على DVP-20PM يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Output على DVP-20PM يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Analog Input على DVP-20PM يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Analog Input على DVP-20PM يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Analog Reading على DVP-20PM تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Analog Output من DVP-20PM مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "High Speed Counter على DVP-20PM ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Encoder ويا DVP-20PM يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Force/Override فعال على DVP-20PM",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-20PM",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-20PM يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Motion/Axis command من DVP-20PM يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "PID داخل DVP-20PM غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "DVP-20PM ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "DVP-20PM يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "بيانات داخل DVP-20PM تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-20pm-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-20PM",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-20PM مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-20PM",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-20PM", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "DVP-50MC ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "DVP-50MC يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "DVP-50MC يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Watchdog مال DVP-50MC يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Scan Time مال DVP-50MC عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "حرارة DVP-50MC ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Battery/Backup مال DVP-50MC ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Memory Error في DVP-50MC",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "بيانات Retain مال DVP-50MC تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "ساعة RTC مال DVP-50MC غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Firmware مال DVP-50MC مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Project داخل DVP-50MC مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Download إلى DVP-50MC يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Upload من DVP-50MC يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-50MC",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-50MC",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-50MC",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Ethernet Link مال DVP-50MC ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-50MC يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-50MC ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-50MC Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-50MC",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-50MC",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-50MC",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-50MC",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Input على DVP-50MC يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Output على DVP-50MC يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Analog Input على DVP-50MC يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Analog Input على DVP-50MC يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Analog Reading على DVP-50MC تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Analog Output من DVP-50MC مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "High Speed Counter على DVP-50MC ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Encoder ويا DVP-50MC يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Force/Override فعال على DVP-50MC",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-50MC",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-50MC يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Motion/Axis command من DVP-50MC يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "PID داخل DVP-50MC غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "DVP-50MC ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "DVP-50MC يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "بيانات داخل DVP-50MC تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-50mc-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-50MC",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-50MC مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-50MC",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-50MC", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "DVP-EC3 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "DVP-EC3 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "DVP-EC3 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Watchdog مال DVP-EC3 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Scan Time مال DVP-EC3 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "حرارة DVP-EC3 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Battery/Backup مال DVP-EC3 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Memory Error في DVP-EC3",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "بيانات Retain مال DVP-EC3 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "ساعة RTC مال DVP-EC3 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Firmware مال DVP-EC3 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Project داخل DVP-EC3 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Download إلى DVP-EC3 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Upload من DVP-EC3 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-EC3",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-EC3",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-EC3",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Ethernet Link مال DVP-EC3 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-EC3 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-EC3 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-EC3 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-EC3",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-EC3",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-EC3",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-EC3",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Input على DVP-EC3 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Output على DVP-EC3 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Analog Input على DVP-EC3 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Analog Input على DVP-EC3 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Analog Reading على DVP-EC3 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Analog Output من DVP-EC3 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "High Speed Counter على DVP-EC3 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Encoder ويا DVP-EC3 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Force/Override فعال على DVP-EC3",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-EC3",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-EC3 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Motion/Axis command من DVP-EC3 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "PID داخل DVP-EC3 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "DVP-EC3 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "DVP-EC3 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "بيانات داخل DVP-EC3 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-ec3-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC3",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-EC3 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC3",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC3", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "DVP-EC5 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "DVP-EC5 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "DVP-EC5 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Watchdog مال DVP-EC5 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Scan Time مال DVP-EC5 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "حرارة DVP-EC5 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Battery/Backup مال DVP-EC5 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Memory Error في DVP-EC5",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "بيانات Retain مال DVP-EC5 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "ساعة RTC مال DVP-EC5 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Firmware مال DVP-EC5 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Project داخل DVP-EC5 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Download إلى DVP-EC5 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Upload من DVP-EC5 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-EC5",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-EC5",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-EC5",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Ethernet Link مال DVP-EC5 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-EC5 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-EC5 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-EC5 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-EC5",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-EC5",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-EC5",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-EC5",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Input على DVP-EC5 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Output على DVP-EC5 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Analog Input على DVP-EC5 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Analog Input على DVP-EC5 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Analog Reading على DVP-EC5 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Analog Output من DVP-EC5 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "High Speed Counter على DVP-EC5 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Encoder ويا DVP-EC5 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Force/Override فعال على DVP-EC5",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-EC5",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-EC5 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Motion/Axis command من DVP-EC5 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "PID داخل DVP-EC5 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "DVP-EC5 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "DVP-EC5 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "بيانات داخل DVP-EC5 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-ec5-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EC5",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-EC5 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EC5",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EC5", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "DVP-ES2 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "DVP-ES2 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "DVP-ES2 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Watchdog مال DVP-ES2 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Scan Time مال DVP-ES2 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "حرارة DVP-ES2 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Battery/Backup مال DVP-ES2 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Memory Error في DVP-ES2",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "بيانات Retain مال DVP-ES2 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "ساعة RTC مال DVP-ES2 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Firmware مال DVP-ES2 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Project داخل DVP-ES2 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Download إلى DVP-ES2 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Upload من DVP-ES2 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-ES2",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-ES2",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-ES2",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Ethernet Link مال DVP-ES2 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-ES2 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-ES2 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-ES2 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-ES2",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-ES2",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-ES2",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-ES2",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Input على DVP-ES2 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Output على DVP-ES2 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Analog Input على DVP-ES2 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Analog Input على DVP-ES2 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Analog Reading على DVP-ES2 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Analog Output من DVP-ES2 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "High Speed Counter على DVP-ES2 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Encoder ويا DVP-ES2 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Force/Override فعال على DVP-ES2",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-ES2",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-ES2 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Motion/Axis command من DVP-ES2 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "PID داخل DVP-ES2 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "DVP-ES2 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "DVP-ES2 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "بيانات داخل DVP-ES2 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-es2-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES2",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-ES2 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES2",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES2", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "DVP-ES3 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "DVP-ES3 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "DVP-ES3 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Watchdog مال DVP-ES3 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Scan Time مال DVP-ES3 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "حرارة DVP-ES3 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Battery/Backup مال DVP-ES3 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Memory Error في DVP-ES3",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "بيانات Retain مال DVP-ES3 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "ساعة RTC مال DVP-ES3 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Firmware مال DVP-ES3 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Project داخل DVP-ES3 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Download إلى DVP-ES3 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Upload من DVP-ES3 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-ES3",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-ES3",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-ES3",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Ethernet Link مال DVP-ES3 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-ES3 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-ES3 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-ES3 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-ES3",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-ES3",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-ES3",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-ES3",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Input على DVP-ES3 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Output على DVP-ES3 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Analog Input على DVP-ES3 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Analog Input على DVP-ES3 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Analog Reading على DVP-ES3 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Analog Output من DVP-ES3 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "High Speed Counter على DVP-ES3 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Encoder ويا DVP-ES3 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Force/Override فعال على DVP-ES3",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-ES3",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-ES3 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Motion/Axis command من DVP-ES3 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "PID داخل DVP-ES3 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "DVP-ES3 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "DVP-ES3 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "بيانات داخل DVP-ES3 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-es3-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-ES3",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-ES3 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-ES3",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-ES3", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "DVP-EX3 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "DVP-EX3 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "DVP-EX3 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Watchdog مال DVP-EX3 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Scan Time مال DVP-EX3 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "حرارة DVP-EX3 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Battery/Backup مال DVP-EX3 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Memory Error في DVP-EX3",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "بيانات Retain مال DVP-EX3 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "ساعة RTC مال DVP-EX3 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Firmware مال DVP-EX3 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Project داخل DVP-EX3 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Download إلى DVP-EX3 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Upload من DVP-EX3 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-EX3",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-EX3",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-EX3",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Ethernet Link مال DVP-EX3 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-EX3 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-EX3 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-EX3 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-EX3",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-EX3",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-EX3",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-EX3",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Input على DVP-EX3 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Output على DVP-EX3 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Analog Input على DVP-EX3 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Analog Input على DVP-EX3 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Analog Reading على DVP-EX3 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Analog Output من DVP-EX3 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "High Speed Counter على DVP-EX3 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Encoder ويا DVP-EX3 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Force/Override فعال على DVP-EX3",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-EX3",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-EX3 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Motion/Axis command من DVP-EX3 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "PID داخل DVP-EX3 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "DVP-EX3 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "DVP-EX3 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "بيانات داخل DVP-EX3 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-ex3-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-EX3",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-EX3 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-EX3",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-EX3", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "DVP-SA2 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "DVP-SA2 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "DVP-SA2 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Watchdog مال DVP-SA2 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Scan Time مال DVP-SA2 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "حرارة DVP-SA2 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Battery/Backup مال DVP-SA2 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Memory Error في DVP-SA2",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "بيانات Retain مال DVP-SA2 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "ساعة RTC مال DVP-SA2 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Firmware مال DVP-SA2 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Project داخل DVP-SA2 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Download إلى DVP-SA2 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Upload من DVP-SA2 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-SA2",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-SA2",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-SA2",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Ethernet Link مال DVP-SA2 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-SA2 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-SA2 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-SA2 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-SA2",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-SA2",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-SA2",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-SA2",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Input على DVP-SA2 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Output على DVP-SA2 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Analog Input على DVP-SA2 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Analog Input على DVP-SA2 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Analog Reading على DVP-SA2 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Analog Output من DVP-SA2 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "High Speed Counter على DVP-SA2 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Encoder ويا DVP-SA2 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Force/Override فعال على DVP-SA2",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-SA2",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-SA2 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Motion/Axis command من DVP-SA2 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "PID داخل DVP-SA2 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "DVP-SA2 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "DVP-SA2 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "بيانات داخل DVP-SA2 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-sa2-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SA2",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-SA2 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SA2",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SA2", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-se-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "DVP-SE ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-se-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "DVP-SE يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-se-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "DVP-SE يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-se-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Watchdog مال DVP-SE يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-se-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Scan Time مال DVP-SE عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-se-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "حرارة DVP-SE ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-se-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Battery/Backup مال DVP-SE ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-se-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Memory Error في DVP-SE",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-se-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "بيانات Retain مال DVP-SE تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-se-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "ساعة RTC مال DVP-SE غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-se-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Firmware مال DVP-SE مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-se-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Project داخل DVP-SE مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-se-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Download إلى DVP-SE يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-se-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Upload من DVP-SE يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-se-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-SE",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-se-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-SE",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-se-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-SE",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-se-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Ethernet Link مال DVP-SE ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-se-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-SE يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-se-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-SE ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-se-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-SE Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-se-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-SE",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-se-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-SE",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-se-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-SE",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-se-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-SE",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-se-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-se-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Input على DVP-SE يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-se-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Output على DVP-SE يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-se-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Analog Input على DVP-SE يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-se-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Analog Input على DVP-SE يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-se-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Analog Reading على DVP-SE تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-se-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Analog Output من DVP-SE مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-se-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "High Speed Counter على DVP-SE ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-se-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Encoder ويا DVP-SE يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-se-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Force/Override فعال على DVP-SE",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-se-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-SE",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-se-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-SE يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-se-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Motion/Axis command من DVP-SE يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-se-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "PID داخل DVP-SE غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-se-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "DVP-SE ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-se-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "DVP-SE يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-se-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "بيانات داخل DVP-SE تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-se-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-SE مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "DVP-SE2 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "DVP-SE2 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "DVP-SE2 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Watchdog مال DVP-SE2 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Scan Time مال DVP-SE2 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "حرارة DVP-SE2 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Battery/Backup مال DVP-SE2 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Memory Error في DVP-SE2",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "بيانات Retain مال DVP-SE2 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "ساعة RTC مال DVP-SE2 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Firmware مال DVP-SE2 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Project داخل DVP-SE2 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Download إلى DVP-SE2 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Upload من DVP-SE2 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-SE2",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-SE2",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-SE2",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Ethernet Link مال DVP-SE2 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-SE2 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-SE2 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-SE2 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-SE2",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-SE2",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-SE2",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-SE2",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Input على DVP-SE2 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Output على DVP-SE2 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Analog Input على DVP-SE2 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Analog Input على DVP-SE2 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Analog Reading على DVP-SE2 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Analog Output من DVP-SE2 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "High Speed Counter على DVP-SE2 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Encoder ويا DVP-SE2 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Force/Override فعال على DVP-SE2",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-SE2",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-SE2 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Motion/Axis command من DVP-SE2 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "PID داخل DVP-SE2 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "DVP-SE2 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "DVP-SE2 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "بيانات داخل DVP-SE2 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-se2-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SE2",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-SE2 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SE2",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SE2", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "DVP-SS2 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "DVP-SS2 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "DVP-SS2 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Watchdog مال DVP-SS2 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Scan Time مال DVP-SS2 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "حرارة DVP-SS2 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Battery/Backup مال DVP-SS2 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Memory Error في DVP-SS2",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "بيانات Retain مال DVP-SS2 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "ساعة RTC مال DVP-SS2 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Firmware مال DVP-SS2 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Project داخل DVP-SS2 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Download إلى DVP-SS2 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Upload من DVP-SS2 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-SS2",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-SS2",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-SS2",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Ethernet Link مال DVP-SS2 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-SS2 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-SS2 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-SS2 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-SS2",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-SS2",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-SS2",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-SS2",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Input على DVP-SS2 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Output على DVP-SS2 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Analog Input على DVP-SS2 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Analog Input على DVP-SS2 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Analog Reading على DVP-SS2 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Analog Output من DVP-SS2 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "High Speed Counter على DVP-SS2 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Encoder ويا DVP-SS2 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Force/Override فعال على DVP-SS2",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-SS2",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-SS2 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Motion/Axis command من DVP-SS2 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "PID داخل DVP-SS2 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "DVP-SS2 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "DVP-SS2 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "بيانات داخل DVP-SS2 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-ss2-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SS2",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-SS2 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SS2",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SS2", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "DVP-SV2 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "DVP-SV2 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "DVP-SV2 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Watchdog مال DVP-SV2 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Scan Time مال DVP-SV2 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "حرارة DVP-SV2 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Battery/Backup مال DVP-SV2 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Memory Error في DVP-SV2",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "بيانات Retain مال DVP-SV2 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "ساعة RTC مال DVP-SV2 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Firmware مال DVP-SV2 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Project داخل DVP-SV2 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Download إلى DVP-SV2 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Upload من DVP-SV2 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-SV2",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-SV2",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-SV2",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Ethernet Link مال DVP-SV2 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-SV2 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-SV2 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-SV2 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-SV2",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-SV2",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-SV2",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-SV2",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Input على DVP-SV2 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Output على DVP-SV2 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Analog Input على DVP-SV2 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Analog Input على DVP-SV2 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Analog Reading على DVP-SV2 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Analog Output من DVP-SV2 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "High Speed Counter على DVP-SV2 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Encoder ويا DVP-SV2 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Force/Override فعال على DVP-SV2",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-SV2",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-SV2 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Motion/Axis command من DVP-SV2 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "PID داخل DVP-SV2 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "DVP-SV2 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "DVP-SV2 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "بيانات داخل DVP-SV2 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-sv2-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV2",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-SV2 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV2",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV2", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "DVP-SV3 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "DVP-SV3 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "DVP-SV3 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Watchdog مال DVP-SV3 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Scan Time مال DVP-SV3 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "حرارة DVP-SV3 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Battery/Backup مال DVP-SV3 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Memory Error في DVP-SV3",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "بيانات Retain مال DVP-SV3 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "ساعة RTC مال DVP-SV3 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Firmware مال DVP-SV3 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Project داخل DVP-SV3 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Download إلى DVP-SV3 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Upload من DVP-SV3 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-SV3",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-SV3",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-SV3",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Ethernet Link مال DVP-SV3 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-SV3 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-SV3 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-SV3 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-SV3",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-SV3",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-SV3",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-SV3",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Input على DVP-SV3 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Output على DVP-SV3 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Analog Input على DVP-SV3 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Analog Input على DVP-SV3 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Analog Reading على DVP-SV3 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Analog Output من DVP-SV3 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "High Speed Counter على DVP-SV3 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Encoder ويا DVP-SV3 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Force/Override فعال على DVP-SV3",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-SV3",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-SV3 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Motion/Axis command من DVP-SV3 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "PID داخل DVP-SV3 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "DVP-SV3 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "DVP-SV3 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "بيانات داخل DVP-SV3 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-sv3-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SV3",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-SV3 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SV3",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SV3", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "DVP-SX ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "DVP-SX يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "DVP-SX يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Watchdog مال DVP-SX يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Scan Time مال DVP-SX عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "حرارة DVP-SX ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Battery/Backup مال DVP-SX ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Memory Error في DVP-SX",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "بيانات Retain مال DVP-SX تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "ساعة RTC مال DVP-SX غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Firmware مال DVP-SX مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Project داخل DVP-SX مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Download إلى DVP-SX يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Upload من DVP-SX يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-SX",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-SX",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-SX",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Ethernet Link مال DVP-SX ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-SX يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-SX ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-SX Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-SX",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-SX",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-SX",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-SX",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Input على DVP-SX يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Output على DVP-SX يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Analog Input على DVP-SX يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Analog Input على DVP-SX يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Analog Reading على DVP-SX تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Analog Output من DVP-SX مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "High Speed Counter على DVP-SX ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Encoder ويا DVP-SX يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Force/Override فعال على DVP-SX",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-SX",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-SX يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Motion/Axis command من DVP-SX يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "PID داخل DVP-SX غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "DVP-SX ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "DVP-SX يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "بيانات داخل DVP-SX تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-sx-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-SX مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "DVP-SX2 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "DVP-SX2 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "DVP-SX2 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Watchdog مال DVP-SX2 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Scan Time مال DVP-SX2 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "حرارة DVP-SX2 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Battery/Backup مال DVP-SX2 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Memory Error في DVP-SX2",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "بيانات Retain مال DVP-SX2 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "ساعة RTC مال DVP-SX2 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Firmware مال DVP-SX2 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Project داخل DVP-SX2 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Download إلى DVP-SX2 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Upload من DVP-SX2 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-SX2",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-SX2",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-SX2",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Ethernet Link مال DVP-SX2 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-SX2 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-SX2 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-SX2 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-SX2",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-SX2",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-SX2",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-SX2",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Input على DVP-SX2 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Output على DVP-SX2 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Analog Input على DVP-SX2 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Analog Input على DVP-SX2 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Analog Reading على DVP-SX2 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Analog Output من DVP-SX2 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "High Speed Counter على DVP-SX2 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Encoder ويا DVP-SX2 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Force/Override فعال على DVP-SX2",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-SX2",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-SX2 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Motion/Axis command من DVP-SX2 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "PID داخل DVP-SX2 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "DVP-SX2 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "DVP-SX2 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "بيانات داخل DVP-SX2 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-sx2-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX2",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-SX2 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX2",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX2", "diagnostic log", "event log", "history"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-no-power",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "DVP-SX3 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "power", "no power", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-stop-mode",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "DVP-SX3 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-unexpected-stop",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "DVP-SX3 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-watchdog",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Watchdog مال DVP-SX3 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "watchdog", "scan time", "cycle"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-scan-time",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Scan Time مال DVP-SX3 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "scan", "performance", "cycle time"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-cpu-overtemp",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "حرارة DVP-SX3 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "temperature", "overheat", "cpu"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-battery",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Battery/Backup مال DVP-SX3 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "battery", "backup", "retain"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-memory",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Memory Error في DVP-SX3",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "memory", "card", "storage"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-retain",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "بيانات Retain مال DVP-SX3 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "retain", "memory", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-rtc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "ساعة RTC مال DVP-SX3 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-firmware",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Firmware مال DVP-SX3 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "firmware", "revision", "compatibility"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-project-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Project داخل DVP-SX3 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "project mismatch", "online offline", "compare"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-download-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Download إلى DVP-SX3 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "download", "transfer", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-upload-fail",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Upload من DVP-SX3 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "upload", "access", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-password",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ DVP-SX3",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "password", "protection", "access"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-programming-connection",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ DVP-SX3",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: ISPSoft / WPLSoft.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "online", "connection", "programming"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-ip-conflict",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ DVP-SX3",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-network-link",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Ethernet Link مال DVP-SX3 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "ethernet", "link", "network"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-industrial-protocol",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا DVP-SX3 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-serial-comm",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا DVP-SX3 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-remote-io",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Remote I/O مرتبط بـ DVP-SX3 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "remote io", "distributed io", "offline"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-module-missing",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Module مفقود من تكوين DVP-SX3",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "module missing", "hardware configuration"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-module-mismatch",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Module type/revision mismatch ويا DVP-SX3",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "module mismatch", "revision"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-backplane",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Backplane/Bus Fault مال DVP-SX3",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "backplane", "bus fault", "rack"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-digital-input",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Digital Input ما يقرا على DVP-SX3",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "digital input", "di", "sensor"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-digital-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "digital output", "do", "relay"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-input-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Input على DVP-SX3 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "input stuck", "di"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-output-stuck",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Output على DVP-SX3 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "output stuck", "welded", "force"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-analog-input-zero",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Analog Input على DVP-SX3 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-analog-input-max",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Analog Input على DVP-SX3 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "analog overrange", "ai"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-analog-noise",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Analog Reading على DVP-SX3 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "analog noise", "shield", "filter"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-analog-output",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Analog Output من DVP-SX3 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "analog output", "ao", "4-20ma"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-hsc",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "High Speed Counter على DVP-SX3 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-encoder",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Encoder ويا DVP-SX3 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "encoder", "position", "a b z"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-force",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Force/Override فعال على DVP-SX3",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "force", "override", "test mode"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-interlock",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من DVP-SX3",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "interlock", "permissive", "logic"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-safety",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ DVP-SX3 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-motion",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Motion/Axis command من DVP-SX3 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-pid",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "PID داخل DVP-SX3 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "pid", "tuning", "control loop"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-startup",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "DVP-SX3 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "startup", "power cycle", "restart"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-random-reset",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "DVP-SX3 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "reset", "reboot", "power dip"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-data-corruption",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "بيانات داخل DVP-SX3 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "delta-delta-dvp-dvp-sx3-diag-log",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: "DVP-SX3",
      code: null,
      title_ar: "Diagnostic/Event log مال DVP-SX3 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "DVP-SX3",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Delta Electronics", "DVP Series", "DVP-SX3", "diagnostic log", "event log", "history"],
    },
  ],
};
